import React, {useEffect, useState} from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import {
  bindMenu,
  bindTrigger,
  usePopupState,
} from "material-ui-popup-state/hooks";
import {useTranslation} from "react-i18next";
import PopupState, {bindPopover} from "material-ui-popup-state";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import {ReactComponent as AppStore} from "@/assets/images/App Store.svg";
import {ReactComponent as ChangeLogsIcon} from "@/assets/images/Change Logs.svg";
import {ReactComponent as GooglePlay} from "@/assets/images/Google Play.svg";
import {LoadingButton} from "@mui/lab";
import {styled} from "@mui/material/styles";
import ChangeLogs from "@/parts/Header/components/ChangeLogs"
import Divider from "@mui/material/Divider";
import UserService from "@/services/auth/UserService";

export const CustomGrid = styled(Grid)(({theme}) => ({
  height: '30px',
  lineHeight: "30px",
  color: '#666666',
  fontSize: '12px'
}));


const Announcement: React.FC = () => {
  const {t} = useTranslation();
  const [openApp, setOpenApp] = useState(false);
  const [openTimesheet, setOpenTimesheet] = useState(false);
  const [openChangelog, setOpenChangelog] = useState(false);
  const [openQRCode, setOpenQRCode] = useState(false);
  const popupState = usePopupState({
    variant: "popover",
    popupId: "announcement",
  });
  const get_data = {
    method: "get",
  };
  useEffect(() => {
    try {
      UserService.firstLoginByChangeLog(get_data).then((response: any) => {
        // setOpenApp(false);
        const is_select = response?.data?.select;
        setOpenTimesheet(!is_select);
      });
    } catch (error) {
      console.log(error);
    }

  }, []);
  const handleSave = () => {
    const post_data = {
      select: true,
      method: "post",
    };
    setOpenTimesheet(false);
    try {
      UserService.firstLoginByChangeLog(post_data).then((response: any) => {
        console.log();
      });
    } catch (error) {
      console.log(error);
    }
  };
  const ChangeLogComponent = () => {
    return (
      <PopupState variant="popover" popupId="demo-popup-popover">
        {(popupState) => (
          <div>
            <Popover
              {...bindPopover(popupState)}
              anchorOrigin={{
                vertical: 70,
                horizontal: "right",
              }}
              open={openChangelog}
              // transformOrigin={{
              //   vertical: 55,
              //   horizontal: "right",
              // }}
            >
              <Grid>
                <Typography
                  sx={{
                    p: 2,
                    width: "500px",
                    backgroundColor: "rgb(255,255,255)",
                  }}
                >
                  <h3 style={{color: "#2BA9DE"}}>Good News !</h3>
                  <li>
                    We have released new Timesheet : Normal Timesheet and
                    Flexible Timesheet.
                  </li>
                  <li>You can try it in the Timesheet feature.</li>
                  <li>
                    Note: Existing Timesheets will not be modified and will use
                    the old attendance calculation method.
                  </li>
                  <Box>
                    {/*<Grid sx={{backgroundColor: "#2BA9DE", opacity: 0.7}}>*/}
                    <Grid sx={{marginTop: "20px"}}>
                      <LoadingButton
                        size={"small"}
                        onClick={() => {
                          setOpenChangelog(false);
                        }}
                        variant={"contained"}
                        sx={{
                          padding: "3px",
                          textTransform: "capitalize",
                          width: "20%",
                          marginLeft: "80%",
                        }}
                      >
                        {t("common.confirm")}
                      </LoadingButton>
                    </Grid>
                  </Box>
                </Typography>
              </Grid>
            </Popover>
          </div>
        )}
      </PopupState>
    )
  }
  return (
    <Box>
      <Tooltip title={t("common.Announcement")}>
        <Grid
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "32px",
            width: "32px",
            marginTop: "4px",
            borderRadius: '50%',
            overflow: 'hidden',
            backgroundColor: "#ffffff",
            cursor: 'pointer'
          }}
          {...bindTrigger(popupState)}
        >
          <i className="icon iconfont icon-ic_news"></i>
        </Grid>
      </Tooltip>
      <PopupState variant="popover" popupId="demo-popup-popover">
        {(popupState) => (
          <div>
            <Popover
              {...bindPopover(popupState)}
              anchorOrigin={{
                vertical: 70,
                horizontal: "right",
              }}
              open={openApp}
              // transformOrigin={{
              //   vertical: 55,
              //   horizontal: "right",
              // }}
            >
              <Grid>
                <Typography
                  sx={{
                    p: 2,
                    width: "500px",
                    backgroundColor: "rgb(255,255,255)",
                  }}
                >
                  <h3 style={{color: "#2BA9DE"}}>Good News !</h3>
                  <li>
                    We have already released the NGTeco Office mobile
                    application!
                  </li>
                  <li>
                    You can search 'NGTeco Office' in Google Play or App Store .
                  </li>
                  <li>
                    You can also scan these QR code to download mobile app .
                  </li>
                  <Box>
                    <Grid sx={{marginTop: "20px"}}>
                      <Grid>
                        <Grid sx={{position: "absolute", left: "60%"}}>
                          <AppStore/>
                        </Grid>
                        <Grid
                          sx={{
                            marginTop: "80px",
                            position: "absolute",
                            left: "60%",
                          }}
                        >
                          <Box>App Store</Box>
                        </Grid>
                      </Grid>
                      <Grid>
                        <Grid sx={{position: "absolute", left: "25%"}}>
                          <GooglePlay/>
                        </Grid>
                        <Grid
                          sx={{
                            marginTop: "80px",
                            position: "absolute",
                            left: "24%",
                          }}
                        >
                          <Box>Google Play</Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box>
                    {/*<Grid sx={{backgroundColor: "#2BA9DE", opacity: 0.7}}>*/}
                    <Grid sx={{marginTop: "150px"}}>
                      <LoadingButton
                        size={"small"}
                        onClick={() => {
                          setOpenApp(false);
                        }}
                        variant={"contained"}
                        sx={{
                          padding: "3px",
                          textTransform: "capitalize",
                          width: "20%",
                          marginLeft: "80%",
                        }}
                      >
                        {t("common.confirm")}
                      </LoadingButton>
                    </Grid>
                  </Box>
                </Typography>
              </Grid>
            </Popover>
          </div>
        )}
      </PopupState>
      <PopupState variant="popover" popupId="demo-popup-popover">
        {(popupState) => (
          <div>
            <Popover
              {...bindPopover(popupState)}
              anchorOrigin={{
                vertical: 70,
                horizontal: "right",
              }}
              open={openQRCode || openTimesheet}
              // transformOrigin={{
              //   vertical: 55,
              //   horizontal: "right",
              // }}
            >
              {openTimesheet && <ChangeLogs/>}
              {openTimesheet && <Box>
                <Grid sx={{marginBottom: "20px", marginRight: "20px"}}>
                  <LoadingButton
                    size={"small"}
                    onClick={() => {
                      setOpenTimesheet(false);
                      handleSave()
                    }}
                    variant={"contained"}
                    sx={{
                      padding: "3px",
                      textTransform: "capitalize",
                      width: "20%",
                      marginLeft: "80%",
                    }}
                  >
                    {t("common.confirm")}
                  </LoadingButton>
                </Grid>
              </Box>}
              {openQRCode && <Grid>
                <Typography
                  sx={{
                    p: 2,
                    width: "600px",
                    backgroundColor: "rgb(255,255,255)",
                  }}
                >
                  <h3 style={{color: "#999999", marginTop: "-10px"}}>Change Logs</h3>
                  <Divider/>
                  <Grid sx={{marginTop: "10px"}}>{t("common.change log text1")}</Grid>
                  <Grid sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    width: '100%',
                    marginTop: "10px"
                  }}>
                    <Grid>
                      <ChangeLogsIcon/>
                    </Grid>
                    <Grid>
                      <a
                        target=""
                        rel="noopener noreferrer"
                        style={{color: "#2BA9DE", textDecoration: 'none', marginLeft: '10px', cursor: "pointer"}}
                        onClick={() => {
                          setOpenQRCode(false);
                          setOpenTimesheet(true);
                        }}
                      >
                        View more details
                      </a>
                    </Grid>
                  </Grid>
                  <Box>
                    <Grid sx={{marginTop: "20px"}}>
                      <LoadingButton
                        size={"small"}
                        onClick={() => {
                          if (openTimesheet) {
                            setOpenTimesheet(false);
                          }
                          if (openQRCode) {
                            setOpenQRCode(false)
                          }
                          if (!openQRCode) {
                            setOpenQRCode(true)
                          }
                        }}
                        variant={"contained"}
                        sx={{
                          padding: "3px",
                          textTransform: "capitalize",
                          width: "20%",
                          marginLeft: "80%",
                        }}
                      >
                        {t("common.confirm")}
                      </LoadingButton>
                    </Grid>
                  </Box>
                </Typography>
              </Grid>}
            </Popover>
          </div>
        )}
      </PopupState>
      <ChangeLogComponent/>
      <Menu
        sx={{mt: "45px"}}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted={true}
        {...bindMenu(popupState)}
      >
        <Grid sx={{
          padding: '10px 16px 16px 16px'
        }}>
          {t("common.Announcement Note")}
        </Grid>
        <MenuItem>
          <CustomGrid
            sx={{color: "#0c0c0c"}}
            onClick={() => {
              setOpenApp(false);
              setOpenTimesheet(false);
              setOpenChangelog(false)
              setOpenQRCode(true)
              popupState.isOpen = false;
            }}
          >
            {t("common.Change Logs")}
          </CustomGrid>
        </MenuItem>
        <MenuItem>
          <CustomGrid
            sx={{color: "#0c0c0c"}}
            onClick={() => {
              setOpenApp(false);
              setOpenTimesheet(false);
              setOpenChangelog(true)
              setOpenQRCode(false)
              popupState.isOpen = false;
            }}
          >
            {t("common.New Timesheet")}
          </CustomGrid>
        </MenuItem>
        <MenuItem>
          <CustomGrid
            sx={{color: "#0c0c0c"}}
            onClick={() => {
              setOpenApp(true);
              setOpenTimesheet(false);
              setOpenChangelog(false)
              popupState.isOpen = false;
            }}
          >
            {t("common.New Mobile Apps")}
          </CustomGrid>
        </MenuItem>
      </Menu>
    </Box>
  );
};
export default Announcement;
